import screenFull from 'screenfull'
import "@/components/echarts-part/kpi/stuff/css/size-rate.css"

export default {
    computed: {
        $_defaultFullscreen() {
            return true;
        },
        $_defaultRequestElement() {
            return undefined;
        },
    },
    created() {
        if (!screenFull.isFullscreen && this.$_defaultFullscreen) {
            this.request(this.$_defaultRequestElement);
        }
        this.setVisible(false);
    },
    mounted() {
        this.fnResize()
        document.addEventListener('resize', this.fnResize);
        document.addEventListener('keydown', this.whenKeyDown);
    },
    beforeDestroy() {
        this.setVisible(true);
        document.removeEventListener('resize', this.fnResize);
        document.removeEventListener('keydown', this.whenKeyDown);
        document.documentElement.style.fontSize = '16px';
    },
    methods: {
        setVisible(visibility) {
            this.$store.commit("base/setShowHeader", visibility, {root: true});
            this.$store.commit("base/setShowSidebar", visibility, {root: true});
        },
        fnResize() {
            let deviceWidth = document.documentElement.clientWidth || window.innerWidth;
            document.documentElement.style.fontSize = (deviceWidth / 125) + 'px';
        },
        switchScreenFull(el) {
            screenFull.toggle(el).then(() => this.fnResize());
        },
        request(el) {
            screenFull.request(el).then(() => this.fnResize());
        },
        exit() {
            screenFull.exit().then(() => this.fnResize());
        },
        whenKeyDown(event) {
            if (event) {
                if (event.code === 'Escape') {
                    this.exit();
                } else if (event.code === 'F9') {
                    this.request(this.$_defaultRequestElement);
                    event.preventDefault();
                }
            }
        }
    }
}